/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-tracker
 * Portfolio-tracker
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    AreaChartDataDto,
    AreaChartDataDtoFromJSON,
    AreaChartDataDtoFromJSONTyped,
    AreaChartDataDtoToJSON,
} from './AreaChartDataDto';
import {
    ChartDataEnum,
    ChartDataEnumFromJSON,
    ChartDataEnumFromJSONTyped,
    ChartDataEnumToJSON,
} from './ChartDataEnum';

/**
 * 
 * @export
 * @interface AreaChartDto
 */
export interface AreaChartDto {
    /**
     * 
     * @type {ChartDataEnum}
     * @memberof AreaChartDto
     */
    chartDataType: ChartDataEnum | null;
    /**
     * 
     * @type {string}
     * @memberof AreaChartDto
     */
    id: string;
    /**
     * 
     * @type {Array<AreaChartDataDto>}
     * @memberof AreaChartDto
     */
    data: Array<AreaChartDataDto>;
}

export function AreaChartDtoFromJSON(json: any): AreaChartDto {
    return AreaChartDtoFromJSONTyped(json, false);
}

export function AreaChartDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): AreaChartDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'chartDataType': ChartDataEnumFromJSON(json['chartDataType']),
        'id': json['id'],
        'data': ((json['data'] as Array<any>).map(AreaChartDataDtoFromJSON)),
    };
}

export function AreaChartDtoToJSON(value?: AreaChartDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'chartDataType': ChartDataEnumToJSON(value.chartDataType),
        'id': value.id,
        'data': ((value.data as Array<any>).map(AreaChartDataDtoToJSON)),
    };
}

